import { Immutable } from "immer";
import React from "react";
import { t } from "ttag";

import { interpolate } from "@thelabnyc/thelabui/src/utils/i18n";

type IProps = Immutable<{
    options: string[];
}>;

export const SelectOptions = ({ options }: IProps): React.JSX.Element => {
    return (
        <>
            {options.map((option) => {
                return (
                    <option key={option} value={option}>
                        {interpolate(t`%s`, [option])}
                    </option>
                );
            })}
        </>
    );
};
